import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { MEDFLYT_LOGO_ICON_ONLY } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";

type Props = {
  totalVisits: number;
  totalHours: string;
  totalAmount: string;
};

const InstaPayCard = (props: Props) => {
  return (
    <CardRoot
      style={{ transformOrigin: "top" }}
      initial={{ opacity: 0, rotateX: 80, scaleX: 0.75, translateY: 100 }}
      animate={{ opacity: 1, rotateX: 0, scaleX: 1, translateY: 0 }}
      transition={{ type: "spring", delay: 0.1, duration: 1 }}
    >
      <CardHeader>
        <CardStat title={translate(STRINGS.VISITS)} value={props.totalVisits} />
        <CardStat title={translate(STRINGS.HOURS)} value={props.totalHours} />
      </CardHeader>
      <CardContent>
        <CardTotalAmount>{props.totalAmount}</CardTotalAmount>
        <CardTotalAmountLabel>{translate(STRINGS.PRE_TAXES)}</CardTotalAmountLabel>
      </CardContent>
      <CardLogoBackground>
        <AppIcon icon={MEDFLYT_LOGO_ICON_ONLY} fill="white" size={112} />
      </CardLogoBackground>
    </CardRoot>
  );
};

const CardRoot = styled(motion.div)`
  background: linear-gradient(260deg, var(--primary-color) 0%, #9108ff 100%);
  border-radius: 24px;
  padding: 24px;
  display: flex;
  height: 35vw;
  max-height: 192px;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
`;

const CardHeader = styled.div`
  display: flex;
  gap: 16px;

  > * + * {
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    padding-inline-start: 16px;
  }
`;

const CardStat = (props: { title: string; value: string | number }) => {
  return (
    <CardStatRoot>
      <CardStatValue>{props.value}</CardStatValue>
      <CardStatLabel>{props.title}</CardStatLabel>
    </CardStatRoot>
  );
};
const CardStatRoot = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CardStatValue = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 700;
`;

const CardStatLabel = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

const CardContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const CardTotalAmount = styled.div`
  color: white;
  font-size: 32px;
  line-height: 24px;
  font-weight: 800;
`;

const CardTotalAmountLabel = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  font-weight: 500;
`;

const CardLogoBackground = styled.div`
  position: absolute;
  right: -8px;
  bottom: -16px;
  opacity: 0.1;
  pointer-events: none;

  svg {
    width: 112px;
  }
`;

export default InstaPayCard;
